import styled from 'styled-components';

const TemperatureContainer = styled.div`
  padding: 0 0 20px 0;
`;

const TemperatureLabel = styled.div`
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 600;
  color: #32325d;
`;

const ProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 60px;
`;

const ProgressBar = styled.div`
  flex: 1;
  height: 8px;
  background: linear-gradient(to right, #4a90e2 0%, #f5a623 50%, #e74c3c 100%);
  border-radius: 10px;
  position: relative;
  margin: 0 35px;
`;

const TemperatureIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #fff;
  z-index: 2;

  &:hover {
    transform: translateY(-50%) scale(1.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
`;

const ColdIndicator = styled(TemperatureIndicator)`
  background-color: #4a90e2;
  left: -12px;
`;

const WarmIndicator = styled(TemperatureIndicator)`
  background-color: #f5a623;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);

  &:hover {
    transform: translateX(-50%) translateY(-50%) scale(1.2);
  }
`;

const HotIndicator = styled(TemperatureIndicator)`
  background-color: #e74c3c;
  right: -12px;
`;

const SelectedIndicator = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  pointer-events: none;
`;

const LabelsContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 35px;
  margin-top: -10px;
`;

const LabelItem = styled.div`
  font-weight: 500;
  line-height: 1.5;
  font-size: 14px;
  color: ${({ $isSelected }) => ($isSelected ? '#525f7f' : '#8898aa')};
  text-align: center;

  &:first-child {
    width: 70px;
    margin-left: -35px;
  }

  &:nth-child(2) {
    flex: 1;
    text-align: center;
  }

  &:last-child {
    width: 70px;
    margin-right: -35px;
  }
`;

export {
  TemperatureContainer,
  TemperatureLabel,
  ProgressBarContainer,
  ProgressBar,
  ColdIndicator,
  WarmIndicator,
  HotIndicator,
  SelectedIndicator,
  LabelsContainer,
  LabelItem
};
